// @flow strict

import * as React from "react";
import { CardBody, Progress, Row } from "reactstrap";

const calculateStars = (data) => {
  // Filtrer les cours ayant des notes valides
  const coursesWithNotes = data.filter((course) => course.note !== null);
  // console.log("coursesWithNotes calculateStars: ", coursesWithNotes);
  // Calculer la moyenne des notes
  const totalNotes = coursesWithNotes.reduce(
    (sum, course) => sum + course.note,
    0
  );
  const averageNote =
    coursesWithNotes.length > 0 ? totalNotes / coursesWithNotes.length : 0;

  // Compter les occurrences de chaque note
  const noteCounts = coursesWithNotes.reduce((counts, course) => {
    counts[course.note] = (counts[course.note] || 0) + 1;
    return counts;
  }, {});

  // Calculer les pourcentages pour chaque note
  const percentNoteCounts = Object.entries(noteCounts).reduce(
    (percentages, [note, count]) => {
      percentages[note] = ((count / totalNotes) * 100).toFixed(2); // Arrondi à 2 décimales
      return percentages;
    },
    {}
  );

  // Générer les étoiles pour la note moyenne
  const fullStars = Math.floor(averageNote);
  const halfStar = averageNote % 1 >= 0.5 ? 1 : 0;
  const emptyStars = 5 - fullStars - halfStar;

  return {
    average: averageNote.toFixed(2), // Arrondi à deux décimales
    noteCounts,
    percentNoteCounts,
    total: totalNotes,
    fullStars: fullStars,
    halfStar: halfStar,
  };
};

function NoteCommentaire({ data = [] }) {
  const [starRender, setStarRender] = React.useState({
    average: 0,
    noteCounts: 0,
    percentNoteCounts: 0,
    total: 0,
    fullStars: 0,
    halfStar: 0,
  });
  const courseComment = data.filter(
    (course) => course.note !== null && course.note !== ""
  );

  const fetchData = async (course_comment) => {
    if (course_comment.length > 0) {
      const starAccount = await calculateStars(course_comment);
      // console.log("starAccount: ", starAccount);
      setStarRender(starAccount);
    }
  };

  const countNumberIn = (note) => {
    // Filtrer les cours ayant des notes valides
    const coursesWithNotes = data.filter(
      (course) => course.note !== null && course.note === note
    );

    return coursesWithNotes.length || 0;
  };

  React.useEffect(() => {
    if (courseComment.length > 0) {
      fetchData(courseComment);
    }
  }, [data]);

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  return (
    data.length > 0 && (
      <div>
        <CardBody className="border-top border-top-dashed p-4">
          <div>
            <h6 className="text-muted text-uppercase fw-semibold mb-4">
              Avis des clients
            </h6>
            <div>
              <div>
                {starRender?.fullStars &&
                starRender?.halfStar &&
                starRender?.average ? (
                  <div className="bg-light px-3 py-2 rounded-2 mb-2">
                    <div className="d-flex align-items-center">
                      {/* {starRender?.stars} */}
                      <div className="flex-grow-1">
                        <div className="fs-16 align-middle text-warning">
                          {Array(5)
                            .fill()
                            .map((_, index) => (
                              <i
                                key={index}
                                className={
                                  index < starRender?.fullStars
                                    ? "ri-star-fill"
                                    : index === starRender?.halfStar
                                    ? "ri-star-half-fill"
                                    : "ri-star-line"
                                }
                              ></i>
                            ))}
                        </div>
                      </div>
                      <div className="flex-shrink-0">
                        <h6 className="mb-0">
                          {starRender?.average} étoiles of 5
                        </h6>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="text-center">
                  <div className="text-muted">
                    Total <span className="fw-medium">{starRender?.total}</span>{" "}
                    avis
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <Row className="align-items-center g-2">
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0">5 étoiles</h6>
                    </div>
                  </div>
                  <div className="col">
                    <div className="p-1">
                      <div className="progress animated-progess progress-sm">
                        <Progress
                          bar
                          color="success"
                          value={starRender?.percentNoteCounts[5]}
                        ></Progress>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0 text-muted">
                        {starRender?.noteCounts[5]}
                      </h6>
                    </div>
                  </div>
                </Row>

                <Row className="align-items-center g-2">
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0">4 étoiles</h6>
                    </div>
                  </div>
                  <div className="col">
                    <div className="p-1">
                      <div className="progress animated-progess progress-sm">
                        <Progress
                          bar
                          color="success"
                          value={starRender?.percentNoteCounts[4]}
                        ></Progress>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0 text-muted">
                        {starRender?.noteCounts[4]}
                      </h6>
                    </div>
                  </div>
                </Row>

                <Row className="align-items-center g-2">
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0">3 étoiles</h6>
                    </div>
                  </div>
                  <div className="col">
                    <div className="p-1">
                      <div className="progress animated-progess progress-sm">
                        <Progress
                          bar
                          color="warning"
                          value={starRender?.percentNoteCounts[3]}
                        ></Progress>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0 text-muted">
                        {starRender?.noteCounts[3]}
                      </h6>
                    </div>
                  </div>
                </Row>

                <Row className="align-items-center g-2">
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0">2 étoiles</h6>
                    </div>
                  </div>
                  <div className="col">
                    <div className="p-1">
                      <div className="progress animated-progess progress-sm">
                        <Progress
                          bar
                          color="success"
                          value={starRender?.percentNoteCounts[2]}
                        ></Progress>
                      </div>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0 text-muted">
                        {starRender?.noteCounts[2]}
                      </h6>
                    </div>
                  </div>
                </Row>

                <Row className="align-items-center g-2">
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0">1 étoile</h6>
                    </div>
                  </div>
                  <div className="col">
                    <div className="p-1">
                      <div className="progress animated-progess progress-sm">
                        <Progress
                          bar
                          color="danger"
                          value={starRender?.percentNoteCounts[1]}
                        ></Progress>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="p-1">
                      <h6 className="mb-0 text-muted">
                        {starRender?.noteCounts[1]}
                      </h6>
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </CardBody>
      </div>
    )
  );
}

export default NoteCommentaire;
